module.exports = __webpack_public_path__ + "bg.19c3e42b72c26eef4260.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/assets/images/bg.jpg
// module id = ../../../../../src/assets/images/bg.jpg
// module chunks = styles